module.exports = __webpack_public_path__ + "img/eye_closed.5c9f51e1.svg";